import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { useTranslation } from 'react-i18next';
import { Button, TextInput, Error } from '@figure/frontlib-gui';
import { FormErrorHandler } from 'shared/components';

const FrozenPin = ({ handleSubmit, serverError }) => {
  const { t } = useTranslation();

  return (
    <>
      <Formik
        initialValues={{ pin: '' }}
        onSubmit={handleSubmit}
        validationSchema={Yup.object().shape({
          pin: Yup.string().required('Required').max(15),
        })}
      >
        {({ values, errors, touched, handleSubmit, setFieldValue }) => (
          <>
            <FormErrorHandler errors={errors} touched={touched} serverError={serverError} />
            <Form onSubmit={handleSubmit}>
              <p>
                You can unfreeze your credit with a single use pin through Experian by visiting{' '}
                <a href="https://www.experian.com/ncaconline/singleusepin" target="_blank" rel="noopener noreferrer">
                  https://www.experian.com/ncaconline/singleusepin
                </a>
                .
              </p>

              <p>
                If you need any assistance with this, please contact us at{' '}
                <a href={`tel:${t('phone.customerService')}`}>{t('phone.customerService')}</a>.
              </p>

              <p>This will not affect your credit.</p>

              <TextInput
                id="pin"
                label="PIN"
                name="pin"
                value={values.pin}
                errorText={touched.pin && errors.pin}
                onChange={(e) => setFieldValue('pin', e.target.value)}
                maxLength="15"
                required
              />

              <Error display="block">{serverError}</Error>

              <Button onClick={handleSubmit} primary large center>
                Submit
              </Button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

FrozenPin.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  serverError: PropTypes.string.isRequired,
};

export default FrozenPin;
